import { create } from 'zustand';
import { PersistOptions, persist } from 'zustand/middleware';

import { DECREMENT, INCREMENT, IS_MULTI_ROOM_DEVICES, StorageNames } from '@/lib/constants';

// the store for managing products in the cart
interface DeviceStore {
  /* This is the customerId. */
  boxQuantity: number;
  podQuantity: number;
  devices: any[];
  setBoxQuantity: (type: string) => void;
  setPodQuantity: (type: string) => void;
  addDevices: (item: any[]) => void;
  removeDevices: (item: any[]) => void;
  updateDevices: (tempId: string, isRecord: boolean) => void;
}

// Define what part of the state to persist
type PersistCustomerState = Pick<DeviceStore, 'devices'>;

const persistOptions: PersistOptions<DeviceStore, PersistCustomerState> = {
  name: StorageNames.DEVICE_STORAGE,
  partialize: (state: DeviceStore) => ({
    boxQuantity: state.boxQuantity,
    podQuantity: state.podQuantity,
    devices: state.devices,
  }),
};

// Create the Zustand store with persistence
export const useDeviceStore = create<DeviceStore>()(
  persist(
    (set, get) => ({
      boxQuantity: 0,
      podQuantity: 0,
      devices: [],

      addDevices: (boxes: any) => {
        const deviceList = get().devices;
        if (IS_MULTI_ROOM_DEVICES) {
          set({ devices: [...deviceList, ...boxes] });
        } else {
          const alreadyExists = deviceList.some(
            (p: { productId: any }) => p.productId === boxes[0]?.productId
          );
          if (!alreadyExists) {
            set({ devices: [...boxes] });
          }
        }
      },

      removeDevices: boxes => {
        set({ devices: [...boxes] });
      },

      updateDevices: (tempId: string, isRecord: boolean) =>
        set(state => ({
          devices: state.devices.map((item: any) =>
            item.tempId === tempId ? { ...item, isRecording: isRecord } : item
          ),
        })),

      setBoxQuantity: (type: string) => {
        let count = get().boxQuantity;
        if (type === INCREMENT) {
          set({
            boxQuantity: count + 1,
          });
        }
        if (type === DECREMENT) {
          set({
            boxQuantity: count - 1,
          });
        }
      },

      setPodQuantity: (type: string) => {
        let count = get().podQuantity;
        if (type === INCREMENT) {
          set({
            podQuantity: count + 1,
          });
        }
        if (type === DECREMENT) {
          set({
            podQuantity: count - 1,
          });
        }
      },
    }),
    persistOptions
  )
);
